import Modal from "./modal";

export default class ShareClassModal extends Modal {
	constructor(companyId) {
		super("shareclasses-modal");
		this.cb = null;
		this.$lpToggle = this.$form.querySelector(
			"[name=\"lp\"]",
		);
		this.$idField = this.$form.querySelector("[name=\"id\"]");
		this.lpMandatoryFields = ["lp-seniority", "lp-multiple"];

		this.$antiDilutionToggle = this.$form.querySelector("[name=\"anti-dilution-toggle\"]");
		this.$taxValueToggle = this.$form.querySelector("[name=\"tax-value-toggle\"]");
		this.$hurdleToggle = this.$form.querySelector("[name=\"hurdle-toggle\"]");
		this.$issueCertificatesToggle = this.$form.querySelector("[name=\"issue-certificates\"]");

		this.$antiDilutionToggle.checked = false;
		this.$taxValueToggle.checked = false;
		this.$hurdleToggle.checked = false;
		this.$lpToggle.checked = false;
		this.$issueCertificatesToggle.checked = false;

		this.$lpContainer = this.$form.querySelector("#lp-container");
		this.$antiDilutionContainer = this.$form.querySelector("#anti-dilution-container");
		this.$taxValueContainer = this.$form.querySelector("#tax-value-container");
		this.$hurdleContainer = this.$form.querySelector("#hurdle-container");
		this.$issueCertificatesContainer = this.$form.querySelector("#issue-certificates-container");


		this.setupModalListeners();
		this.updateContainers();

	}

	setCallback(cb) {
		this.cb = cb;
	}

	setupModalListeners() {
		this.$antiDilutionToggle.addEventListener("change", () => {
			if (!this.$antiDilutionToggle.checked) {
				this.$antiDilutionContainer.classList.add("collapse");
				this.$form.querySelector("[name=\"anti-dilution\"]").value = 0;
			} else {
				this.$antiDilutionContainer.classList.remove("collapse");
			}
		});

		this.$taxValueToggle.addEventListener("change", () => {
			if (!this.$taxValueToggle.checked) {
				this.$taxValueContainer.classList.add("collapse");
				this.$form.querySelector("[name=\"tax-value\"]").value = 0;
			} else {
				this.$taxValueContainer.classList.remove("collapse");
			}
		});

		this.$hurdleToggle.addEventListener("change", () => {
			if (!this.$hurdleToggle.checked) {
				this.$hurdleContainer.classList.add("collapse");
				this.$form.querySelector("[name=\"hurdle\"]").value = 0;
			} else {
				this.$hurdleContainer.classList.remove("collapse");
			}
		});

		this.$issueCertificatesToggle.addEventListener("change", () => {
			if (!this.$issueCertificatesToggle.checked) {
				this.$issueCertificatesContainer.classList.add("collapse");
				this.$form.querySelector("[name=\"certificate-series\"]").value = "";
			} else {
				this.$issueCertificatesContainer.classList.remove("collapse");
			}
		});

		const $lpCap = document.querySelector("[name=\"lp-cap\"]");
		document.querySelectorAll("[name=\"lp-participating\"]").forEach((el) => {
			el.addEventListener("change", () => {
				if (el.checked) {
					$lpCap.removeAttribute("disabled");
				} else {
					$lpCap.value = 0;
					$lpCap.setAttribute("disabled", "disabled");
				}
			});
		});

		document
			.querySelector("[name=\"lp-interest\"]")
			.addEventListener("input", (e) => {
				const isFilled = e.target.value > 0;
				document
					.querySelectorAll("[name=\"lp-interest-days\"]")
					.forEach((btn) => {
						if (isFilled) {
							btn.removeAttribute("disabled");
						} else {
							btn.checked = false;
							btn.setAttribute("disabled", "disabled");
						}
					});

				// autocheck interest days
				if (
					isFilled &&
					this.$form.querySelector("[name=\"lp-interest-days\"]:checked") === null
				) {
					this.$form.querySelector(
						"[name=\"lp-interest-days\"][value=\"365\"]",
					).checked = true;
				}
			});

		this.$form.querySelector("[name=\"lp-interest\"]").dispatchEvent(new Event("input"));

		this.$lpToggle.addEventListener("change", () => {
			if (!this.$lpToggle.checked) {
				this.$lpContainer.classList.add("collapse");

			} else {
				this.$form.querySelector("[name=\"lp-interest\"]").value = 0;
				this.$lpContainer.classList.remove("collapse");
			}

			this.lpMandatoryFields.forEach((fieldName) => {
				const $el = document.querySelector("[name=\"" + fieldName + "\"]");

				if (this.$lpToggle.checked) {
					$el.setAttribute("required", "required");
				} else {
					$el.value = 0;
					$el.removeAttribute("required");
				}
			});
		});
	}

	validateAndSendForm() {
		this.enableSubmitButton(false);
		let data = {
			id: parseInt(this.$idField.value) || null,
			company: window.currentCompany.id,
			name: this.$form.querySelector("[name=\"name\"]").value,
			price:
				parseFloat(this.$form.querySelector("[name=\"price\"]").value) || null,
			authorized_shares: parseInt(this.$form.querySelector("[name=\"authorized-shares\"]").value) || null,
			voting_right: this.$form.querySelector("[name=\"voting-right\"]").checked,
			dividend_right: this.$form.querySelector("[name=\"dividend-right\"]")
				.checked,
			anti_dilution:
				parseInt(this.$form.querySelector("[name=\"anti-dilution\"]").value) ||
				null,
			tax_value:
				parseFloat(this.$form.querySelector("[name=\"tax-value\"]").value) ||
				null,
			hurdle:
				parseFloat(this.$form.querySelector("[name=\"hurdle\"]").value) || null,
			notes: this.$form.querySelector("[name=\"notes\"]").value || null,
			issue_certificates: this.$form.querySelector(
				"[name=\"issue-certificates\"]",
			).checked,
			lp: this.$form.querySelector("[name=\"lp\"]").checked,
			lp_seniority:
				parseInt(this.$form.querySelector("[name=\"lp-seniority\"]").value) ||
				null,
			lp_multiple:
				parseFloat(this.$form.querySelector("[name=\"lp-multiple\"]").value) ||
				null,
			lp_participating:
				this.$form.querySelector("[name=\"lp-participating\"]").checked ? 1 : 0,
			lp_cap:
				parseFloat(this.$form.querySelector("[name=\"lp-cap\"]").value) || null,
			lp_interest:
				parseFloat(this.$form.querySelector("[name=\"lp-interest\"]").value) ||
				null,
			lp_interest_days:
				this.$form.querySelector("[name=\"lp-interest-days\"]:checked") != null
					? parseInt(
						this.$form.querySelector("[name=\"lp-interest-days\"]:checked")
							.value,
					)
					: null,
			certificate_series: this.$form.querySelector("[name=\"issue-certificates\"]:checked") != null
				? this.$form.querySelector("[name=\"certificate-series\"]").value
				: null,
		};

		peque
			.api("shareclasses" + (data.id ? "/" + data.id : ""), data, "post")
			.then((response) => {
				this.$modal.hide();

				if (typeof this.cb !== "undefined" && this.cb != null) {
					this.cb(response.result);
					this.enableSubmitButton(true);
				} else {
					location.reload();
				}
			})
			.catch((error) => {
				this.enableSubmitButton(true);

				if (typeof error.field === "undefined") {
					throw error;
				}
				this.showErrorOnField(
					error.result,
					this.$form.querySelector("[name=\"" + error.field + "\"]"),
				);
			});
	}

	prefillForm(shareClass) {
		const fieldsConversion = {
			id: {},
			name: {},
			price: {},
			authorized_shares: {},
			voting_right: {
				type: "boolean",
			},
			dividend_right: {
				type: "boolean",
			},

			lp_seniority: {},
			lp_multiple: {},
			lp_participating: {
				type: "boolean",
			},
			lp_cap: {},
			lp_interest: {},
			lp_interest_days: {
				type: "radio",
			},
			anti_dilution: {
				type: "toggle",
			},
			tax_value: {
				type: "toggle",
			},
			hurdle: {
				type: "toggle",
			},
			issue_certificates: {
				type: "boolean",
			},
			certificate_series: {},
			notes: {},
		};

		this.$lpToggle.checked = shareClass.lp_multiple > 0;

		if (shareClass.lp_interest > 0) {
			const $lpInterest = this.$form.querySelector("[name=\"lp-interest\"]");
			$lpInterest.value = shareClass.lp_interest;
			$lpInterest.dispatchEvent(new Event("input"));
		}
		Object.keys(fieldsConversion).forEach((entityName) => {
			const conversion = fieldsConversion[entityName];

			if (typeof conversion.name === "undefined") {
				conversion.name = entityName.replaceAll("_", "-");
			}
			if (typeof conversion.type === "undefined") {
				conversion.type = "normal";
			}

			if (shareClass[entityName] !== null) {
				switch (conversion.type) {
					case "radio":
						let radio = this.$form
							.querySelector(
								"[name=\"" +
								conversion.name +
								"\"][value=\"" +
								shareClass[entityName] +
								"\"]",
							);
						if (radio !== null) {
							radio.checked = Boolean(shareClass[entityName]);
						}
						break;
					case "boolean":
						this.$form.querySelector(
							"[name=\"" + conversion.name + "\"]",
						).checked = Boolean(shareClass[entityName]);
						break;
					case "toggle":
						this.$form
							.querySelector("[name=\"" + conversion.name + "-toggle\"]")
							.checked = Boolean(shareClass[entityName]);
						this.$form.querySelector("[name=\"" + conversion.name + "\"]").value =
							shareClass[entityName];
						break;
					default:
						if (shareClass[entityName] !== 0) {
							this.$form.querySelector("[name=\"" + conversion.name + "\"]").value =
								shareClass[entityName];
						}
						break;
				}
			} else {
				if (!conversion.type) {
					this.$form.querySelector("[name=\"" + conversion.name + "\"]").value = "";
				}
			}
		});
		this.updateContainers();

	}

	updateContainers() {
		this.$lpToggle.dispatchEvent(new Event("change"));
		this.$antiDilutionToggle.dispatchEvent(new Event("change"));
		this.$taxValueToggle.dispatchEvent(new Event("change"));
		this.$hurdleToggle.dispatchEvent(new Event("change"));
		this.$issueCertificatesToggle.dispatchEvent(new Event("change"));
	}

	show() {
		super.show();
		this.updateContainers();
	}
}
